import { Component, OnInit } from "@angular/core";
import { PeriodState } from "@Interfaces/index";
import { AdfiGrowlService } from "@services/adfi-growl.service";
import { AdfiService } from "@services/adfi-service";

@Component({
    selector: "app-execution-progress",
    templateUrl: "./execution-progress.component.html",
    styleUrls: ["./execution-progress.component.scss"],
})
export class ExecutionProgressComponent implements OnInit {
    canView: boolean;
    percentage = 0;
    progressColor = "#ef4444";
    progressGradient = "linear-gradient(90deg, #fee2e2 0%, #ef4444 100%)";

    constructor(
      protected adfiService: AdfiService,
      private adfiGrowlService: AdfiGrowlService
    ) {
        this.canView = this.adfiService.validPermission("Alerts", "viewExecutionPercentage", PeriodState.NO_STATUS);
    }

    ngOnInit(): void {
      if (this.canView) {
        this.generatecharts(
            this.adfiService.user.centroCosto._id,
            this.adfiService.user.period
        );
      }
    }

    generatecharts(cencos, period: number) {
        this.adfiService.getActivePassive(period, cencos).subscribe(
            (data) => {
                let expenses = data.expenses;
                let total_payments = 0;
                let total_budget = 0;
                expenses.forEach((e) => {
                    total_payments += parseFloat(e.PAYMENT_ORDERS);
                    total_budget += parseFloat(e.PRESUPUESTO_FINAL);
                });
                this.percentage =
                    total_budget > 0
                        ? (total_payments / total_budget) * 100
                        : 0;
                this.setProgressStyle(this.percentage);
            },
            (error) => {
                this.adfiGrowlService.errorMessage("Problema al cargar los datos");
            }
        );
    }
     
    private setProgressStyle(value: number): void {
        const clamped = Math.max(0, Math.min(100, value || 0));

        if (clamped <= 40) {
            this.progressColor = "#ef4444";
            this.progressGradient =
                "linear-gradient(90deg, #fee2e2 0%, #ef4444 100%)";
        } else if (clamped <= 70) {
            this.progressColor = "#f59e0b";
            this.progressGradient =
                "linear-gradient(90deg, #fef3c7 0%, #f59e0b 100%)";
        } else {
            this.progressColor = "#22c55e";
            this.progressGradient =
                "linear-gradient(90deg, #dcfce7 0%, #22c55e 100%)";
        }
    }
}
